<template>
  <div class="store-activity">
    <NavHeaderBar :navBarTitle="`${paramsUrl.pageType === 'salesDistribution' ? $t('shared.distributor') : $t('shared.store')} ${$t('shared.activity')}`" @backReturn="backReturn"></NavHeaderBar>
    <div class="tabs-content">
      <div class="tab-item" :class="{'active-item': tabActive === subItem.value}" v-for="subItem in tabsList" :key="subItem.value" @click="handleTabs(subItem)">{{ subItem.label }}</div>
    </div>
    <!-- Date Filter Bar -->
    <!-- <div class="filter-bar-wrapper" v-if="tabActive === '1'">
      <div class="filter-bar">
        <div class="date-trigger">
          <span class="date-text" :class="{'date-color': dateRangeText !== 'Time'}" @click="showCalendar = true">{{ dateRangeText }}</span>
          <van-icon name="cross" class="clear-icon" v-if="dateRangeText !== 'Time'" key="clear" @click.stop="clearDate" />
          <van-icon name="play" class="arrow-icon" v-else key="arrow" @click.stop="showCalendar = true" />
        </div>
      </div>
    </div> -->
    <UserFilter
      v-show="tabActive === '1'"
      pageType="storeActivity"
      @filter-change="onFilterChange"
    />
    <!-- Activity List -->
    <div class="sub-filter" v-show="tabActive === '1'">
      <div>{{ $t('form.total') }}：{{ totalCount }} {{ $t('shared.records') }}</div>
      <van-checkbox v-model="isHide" shape="square" @change="handleOper">{{ $t('shared.hideUpdate') }}</van-checkbox>
    </div>
    <div class="list-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad" :immediate-check="false">
          <Dynamics v-if="tabActive === '1'" :list="list" />
          <UpdateRecord v-else :list="list" />
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- Calendar Popup -->
    <van-calendar v-model="showCalendar" type="range" :min-date="minDate" :max-date="maxDate" color="#1989fa" @confirm="onConfirmDate" allow-same-day />
  </div>
</template>

<script>
import moment from 'moment'
import { Toast } from 'vant'
import { arsOperationActionListPageApi, customerActivityLogPageApi, sdActivityLogPageApi } from '@/api/home'
export default {
  name: 'StoreActivity',
  components: {
    UpdateRecord: () => import('./components/updateRecord'),
    Dynamics: () => import('./components/dynamics'),
    UserFilter: () => import('@/views/User/UserFilter')
  },
  data () {
    return {
      showCalendar: false,
      // Default range: Last 30 days or similar? Screenshot shows 2023.11.13-2024.1.1
      startDate: '',
      endDate: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),

      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      tabsList: [
        { label: this.$t('shared.dynamics'), value: '1' }, // 激励记录
        { label: this.$t('shared.updateRecord'), value: '2' } // 账号管理
      ],
      tabActive: '1',
      typeList: [
        { label: this.$t('shared.mapping'), value: '0' },
        { label: this.$t('shared.visitSellIn'), value: '4' },
        { label: this.$t('shared.transferAllocation'), value: '6' },
        { label: this.$t('shared.visit'), value: '3' },
        { label: this.$t('shared.reorder'), value: '5' },
        { label: this.$t('shared.popUp'), value: '1' },
        { label: this.$t('shared.title.incentive'), value: '2' }
      ],
      labelType: '',
      isHide: false,
      totalCount: 0,
      paramsUrl: {}
    }
  },
  computed: {
    dateRangeText () {
      if (!this.startDate || !this.endDate) return 'Time'
      const start = moment(this.startDate).format('YYYY.M.D')
      const end = moment(this.endDate).format('YYYY.M.D')
      return `${start} - ${end}`
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.page = 1
    // this.startDate = ''
    // this.endDate = ''
    // this.tabActive = '1'
    // this.labelType = ''
    // Initial load
    this.onLoad()
  },
  methods: {
    handleOper (val) {
      this.onRefresh()
    },
    onFilterChange (data) {
      this.labelType = data.product
      this.startDate = data.startDate
      this.endDate = data.endDate
      this.onRefresh()
    },
    handleTabs (params) {
      this.tabActive = params.value
      this.onRefresh()
    },
    onConfirmDate (date) {
      const [start, end] = date
      this.startDate = moment(start).format('YYYY-MM-DD')
      this.endDate = moment(end).format('YYYY-MM-DD')
      this.showCalendar = false

      // Reset list and reload
      this.onRefresh()
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    clearDate () {
      this.startDate = ''
      this.endDate = ''
      this.onRefresh()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10
      }
      if (this.tabActive === '1') {
        data.label = this.labelType
        data.operationId = this.$route.query.customerId
        data.startTime = this.startDate
        data.endTime = this.endDate
        data.isHide = this.isHide
      } else {
        data.actionId = this.$route.query.customerId
        data.source = this.paramsUrl.pageType === 'salesDistribution' ? 1 : 0
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      let resquestApi = ''
      if (this.tabActive === '1') {
        resquestApi = this.paramsUrl.pageType === 'salesDistribution' ? sdActivityLogPageApi : customerActivityLogPageApi
      } else {
        resquestApi = arsOperationActionListPageApi
      }
      resquestApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.list = res.data.list
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.loading = false
        this.page++
        this.totalCount = Number(res.data.totalRow)
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    backReturn () {
      this.$destroy()
    }
  }
}
</script>

<style lang="less" scoped>
.store-activity {
  // background-color: #f5f5f9;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .sub-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #f5f5f9;
  }

  .tabs-content {
    display: flex;
    align-items: center;
    padding: 16px 10px 0;
    background-color: #fff;
    .tab-item {
      padding: 5px 10px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: bold;
      font-size: 13px;
    }
    .active-item {
      color: #fff;
      background-color: #307bff;
    }
  }

  .filter-bar-wrapper {
    display: flex;
    align-items: center;
    height: 40px;
    // position: sticky; // No longer needed for flex layout with scrollable content
    // top: 46px;
    z-index: 99;
  }

  .filter-bar {
    padding: 0px 20px;
    // background-color: #f5f5f9;

    .date-trigger {
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;

      .date-color {
        color: #307bff;
      }

      .clear-icon {
        margin-left: 8px;
        font-size: 16px;
        color: #666;
        padding: 4px;
      }

      .arrow-icon {
        margin-left: 4px;
        font-size: 10px;
        transform: rotate(90deg);
        color: #000; // Arrow seems black/dark grey in screenshot
      }
    }
  }

  .list-content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>
